import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';

import usePatientSearch from '~/utils/patient/search/hook';

import Form from './Form';

const IdentitySearchCard = ({ afterSubmit }) => {
  const { setResults, setStatus } = usePatientSearch();

  return (
    <Card className="rounded-0">

      <Form
        setResults={setResults}
        setStatus={setStatus}
        afterSubmit={afterSubmit}
      />
    </Card>
  );
};

IdentitySearchCard.propTypes = {
  afterSubmit: PropTypes.func,
};

IdentitySearchCard.defaultProps = {
  afterSubmit: () => {},
};

export default IdentitySearchCard;
